import React, { useRef, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import { uniqueId } from 'lodash-es';

export const FjPortal: React.FC<FjDivProps> = ({ className = 'fj', children }: FjDivProps) => {
  const divRef = useRef<HTMLDivElement>(document.createElement('div'));

  useLayoutEffect(() => {
    divRef.current.setAttribute('id', uniqueId(`${className}-portal-`));
    divRef.current.setAttribute('class', `${className}-portal`);
    document.body.appendChild(divRef.current);
    return () => {
      document.body.removeChild(divRef.current);
    };
  }, []);

  return ReactDOM.createPortal(children, divRef.current);
};
